const isAlkanes = (slug: string) => {
	return slug && slug.startsWith('alkane-')
}

export default isAlkanes
